module.exports = __webpack_public_path__ + "img/choice.82742ca4.png";